/*jshint esversion: 6*/
import { imeiMd5Key, browserTrackCategory } from './conf';
import { api__ELK404, api__elkLog } from './api';

function Utils__ObjectEach(obj, callback) {
    let key;
    const hasOwn = Object.prototype.hasOwnProperty;

    for (key in obj) {
        if (hasOwn.call(obj, key)) {
            callback(key, obj[key]);
        }
    }
}

export function Utils__isMiuiBrowser(UA) {
    return  /XiaoMi\/MiuiBrowser\/([\d\.]+)(-Beta)?$/.test(UA);
}

export function Utils__isMiuiBrowserBeta(UA) {
    return  /XiaoMi\/MiuiBrowser\/([\d\.]+)-Beta$/.test(UA);
}

export function Utils__isXiangkan(UA) {
    return /XiaoMi\/MiuiBrowser\/([\d\.]+)(.*?bikan\/([\d\.]+).*?)$/.test(UA);
}

function Utils__isIOS(UA) {
    return /(iPhone|iPad|iPod|iOS)/i.test(UA);
}

export function Utils__isYiDianZiXun() {
    return location.href.indexOf('yidianzixun.com') > -1;
}

export function Utils__isQuanQiuShangWang() {
    return location.href.indexOf('mi_source=openrec') > -1;
}

export function Utils__isQuickGame() {
    const reg = /com\.xiaomi\.gameloading\.mi/;
    const ua = window.navigator.userAgent;

    return reg.test(ua);
}

export function Utils__decodeUrl(s) {
    return decodeURIComponent(s.replace(/\+/g, ' ').replace(/%/g, '%25'));
}

export function Utils__parseQuery(query) {
    let ret = {};
    let i;
    let pair;
    const vars = query && query.split('&') || [];

    for (i = 0; i < vars.length; i++) {
        if (vars[i]) {
            pair = vars[i].split('=');
            ret[Utils__decodeUrl(pair[0])] = Utils__decodeUrl(pair[1] || '');
        }
    }

    return ret;
}

export function Utils__param(data, url) {
    let ret = '';
    let i;

    Utils__ObjectEach(data, (key, value) => {
        if (value != undefined) {
            if (value instanceof Array) {
                for (i = 0; i < value.length; i++) {
                    ret += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value[i]);
                }
            } else {
                ret += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value);
            }
        }
    });

    return url != undefined ? (url + ret).replace(/[&?]{1,2}/, '?') : ret.substr(1);
}

export function Utils__random(possible, len) {
    let ret = '';
    let i;

    for (i = 0; i < len; i++) {
        ret += possible[Math.floor(Math.random() * possible.length)];
    }

    return ret;
}

export function Utils__getImeiMd5() {
    const hex = '0123456789abcdef';

    try {
        return window.miui.getImeiMD5();
    } catch (e) {
        // 保证尽可能少的生成 imeiMd5，避免冲突
        if (localStorage[imeiMd5Key]) {
            return localStorage[imeiMd5Key];
        }

        localStorage[imeiMd5Key] = Utils__random(hex, 32);
        return localStorage[imeiMd5Key];
    }
}

export function Utils__getFakeImeiMd5() {
  const hex = '0123456789abcdef';

  try {
    return window.miui.getImeiMD5();
  } catch (e) {
    // 保证尽可能少的生成 imeiMd5，避免冲突
    if (localStorage.fakeImeiMd5) {
      return localStorage.fakeImeiMd5;
    }

    localStorage.fakeImeiMd5 = Utils__random(hex, 32);
    return localStorage.fakeImeiMd5;
  }
}

export function Utils__getDeviceInfo() {
    try {
        return JSON.parse(window.miui.getDeviceInfo());
    } catch (e) {
        return null;
    }
}

export function Utils__getNetworkTypeName() {
  try {
    return window.miui.getActiveNetworkTypeName();
  } catch (e) {
    return null;
  }
}

export function Utils__getQuery(url, param) {
    var query = Utils__parseQuery(url.split('?')[1]);

    if (param) {
        query = query[param];
    }

    return query;
}

export function Utils__isSharePage(url) {
    return Utils__getQuery(url, 'share');
}

export function Utils__getShareTarget(url, shareMap) {
    const share = Utils__isSharePage(url);

    return shareMap[share] || '';
}

export function Utils__displayShareBar(UA, url) {
    return Utils__isSharePage(url) && !Utils__isIOS(UA);
}

export function Utils__getUserAccountInfo() {
  try {
    return JSON.parse(window.miui.getUserAccountInfo());
  } catch (e) {
    return null;
  }
}

export function Utils__urlParse(url, type) {
  const a = window.document.createElement('a');
  a.href = url;

  return a[type] || url;
}

export function Utils__splitUrl(url) {
    const host = /feed.(dev.)?browser.miui.com/;

    if (url && host.test(url)) {
        return url.split('#')[1];
    } else {
        return url.split('?')[1];
    }
}

export function Utils__checkErrorPage(cb) {
    var func = function() {
        if (document.getElementById('mi-detail-error') ||
            ~location.href.indexOf('zaker.com/news/404_xiaomi')  //zaker 错误页结构不同
        ) {
            cb();
            return true;
        }
    },
        timer = setTimeout(func, 1000); // uc错误页面dom异步填充

    if (func()) {
        clearTimeout(timer);
    }
}

export function Utils__getQueryString() {
    var query = (location.search || location.href).split('?')[1];

    if (~location.origin.indexOf('peopletech.cn')) {
        query = location.hash.split('?')[1]; // 针对人民网特殊处理
    }

    return query;
}

export function Utils__checkInitTime(callback, isFirst) {
    var host = location.hostname,
        hostList = [
            'm.uczzd.cn',
            'share.iclient.ifeng.com',
            'c2.m.ifeng.com'
        ];

    if (host && ~hostList.indexOf(host)) {
        if (!isFirst) {
            callback();
        }
    } else if (isFirst === true) {
        Utils__ready(callback);
    }
}

// https://github.com/madrobby/zepto/blob/master/src/zepto.js
export function Utils__ready(cb) {
    var done = false;

    if (document.readyState === 'complete' ||
        (document.readyState !== 'loading' && !document.documentElement.doScroll)
    ) {
        cb();
    } else {
        var handler = function(e) {
            if (e.type == 'readystatechange' && document.readyState != 'complete') {
                return;
            }

            document.removeEventListener('DOMContentLoaded', handler, false);
            window.removeEventListener('load', handler, false);

            if (!done && (done = true)) {
                cb();
            }
        };

        document.addEventListener('DOMContentLoaded', handler, false);
        document.addEventListener('readystatechange', handler, false);
        window.addEventListener('load', handler, false);
    }
}

export function Utils__elk404(pid, pname) {
  Utils__ready(function () {
    Utils__checkErrorPage(function () {
      var state = Utils__parseQuery(Utils__getQueryString()),
          deviceMessage = Utils__getDeviceMessage();

      api__ELK404({
        imei: deviceMessage.imei2,
        oaid: deviceMessage.oaid,
        uid: '-1',
        app_version: location.href,
        app_name: window.navigator.appName,
        ua: window.navigator.userAgent,
        pid: pid,
        pname: pname,
        timestamp: Date.now(),
        hostname: location.hostname,
        pathname: location.pathname,
        type: '404',
        ext: JSON.stringify({
          name: '文章详情页',
          cate: '死链上报',
          action: '曝光',
          path: state.cateCode,
          url: location.href,
          cp: state.cp
        })
      });
    });
  });
}

export function Utils__elkLog(params) {
  var deviceInfo = Utils__getDeviceInfo() || {},
      imei = Utils__getImeiMd5(),
      data = {
        imei: imei,
        user_id: '',
        device_id: '',
        region: deviceInfo.region,
        version: deviceInfo.version_name,
        packageName: deviceInfo.package_name,
        network: Utils__getNetworkTypeName(),
        language: deviceInfo.language,
        model: deviceInfo.model,
        os: '',
        source: 'browser-feed',
        key: params.key,
        value: JSON.stringify(params.value),
        timestamp: Date.now()
      };

  api__elkLog(data);
}

export function utils__Numbershort(number) {
  var limit = [1000, 10000, 100000, 1000000],
    map = [
      function (number) {
        return number;
      },
      function (number) {
        return Math.toFixed(number / 1000, 1) + 'K';
      },
      function (number) {
        return Math.toFixed(number / 10000, 1) + 'W';
      },
      function (number) {
        return Math.toFixed(number / 10000, 0) + 'W';
      }
    ];

  for (var i = 0, len = limit.length; i < len; i += 1) {
    if (number < limit[i]) {
      return map[i](number);
    }
  }

  return '100W+';
}

export function Utils__getBrowserCategory(code) {
    var category;

    //兼容用户中心，用户中心的该字段为path值，中文
    if (/^.*[\u4e00-\u9fa5]+.*$/.test(code)) {
        return code;
    }

    browserTrackCategory.some(function(item) {
        if (item.code == code) {
            category = item.name;
        }
    });

    return category || '未知';
}

/**
 * 获取MIUI系统是否是稳定版，通过getDeviceInfo方法获取的stable字段。
 * stable字段值：alpha(体验版)， dev(开发版)， stable(稳定版)，alpha1(某些特殊情况)
 */
export function Utils__isMiuiRomStable() {
    var device = Utils__getDeviceInfo() || {},
        stable = device.stable;

    return stable === 'stable';
}

export function Utils__copy(data) {
  let res = false;

  const input = document.createElement('input');
  input.setAttribute('readonly', 'readonly');
  input.setAttribute('value', data);
  document.body.appendChild(input);
  input.select();

  // ios需要这函数
  input.setSelectionRange(0, 9999);

  if (document.execCommand('copy')) {
    // document.execCommand('copy');
    res = true;
    console.log('复制成功', data);
  } else {
    console.log('复制失败', data);
  }
  document.body.removeChild(input);
  return res;
}

export function Utils__isMiuiQuickSearchBox() {
  const ua1 = 'XiaoMi/MiuiQuickSearchBox/';
  const ua2 = 'XiaoMi/HybridView/';
  const ua = window.navigator.userAgent;

  if (ua.indexOf(ua1) > -1 || ua.indexOf(ua2) > -1) {
    return true;
  }

  return false;
}

export function Utils__isNobBackflow() {
  const isMiuiQuickSearchBox = Utils__isMiuiQuickSearchBox();
  // 非想看分享
  const isNoShare = location.href.indexOf('share=') < 0;
  // 禁止 backflow；参数可能在 query 中也可能在 hash 中
  const isNobBackflow = location.href.indexOf('backflow=0') > -1;

  if (isMiuiQuickSearchBox
    || isNoShare
    || isNobBackflow
  ) {
    return true;
  }

  return false;
}

export function Utils__isMiWebViewSDK() {
  const u = navigator.userAgent;
  const regexp = /Chrome\/([\d.]+)/i;
  const matchs = u.match(regexp) || [];
  const chromeVersion = matchs[1];
  const isMB = u.indexOf('XiaoMi/MiuiBrowser') > -1;

  if (isMB && chromeVersion && parseFloat(chromeVersion) >= 71) {
    return true;
  }

  return false;
}

export function Utils__getShareChannel(UA) {
    const shareChannels = [
        {reg: / MicroMessenger/, channel: '微信'},
        {reg: / QQ/, channel: 'QQ'},
        {reg: / Weibo/, channel: '微博'},
    ];
    let channel;

    shareChannels.some(function(obj){
        if (obj.reg.test(UA)) {
            channel = obj.channel;
            return true;
        }
    });

    return  channel;
}

export function Utils__noTopBar() {
    try {
        return window.miui.noTopBar()  == 'y';
    } catch (e) {}
}

/**
 * Linear滚动动画
 * 若滚动距离大于最长滚动距离，则动画从最长滚动距离开始，否则从当前位置开始滚动。
 * params:
 *      $scroll 滚动元素
 *      to 滚动目标位置
 *      duration 动画时长
 *      scrollHeight 最长滚动距离
 */
export function Utils__scrollToWithLinear($scroll = window, to, duration = 200, scrollHeight = 400) {
    let scrollTop = $scroll.scrollTop;
    let distance = Math.abs(to - scrollTop);
    const upOrDown = scrollTop < to ? 1 : -1; // 判断是向上滑还是向下滑，1：向上滑，-1：向下滑
    const gap = Math.min(distance, scrollHeight) / Math.floor(duration / 16);
    const step = function () {
            distance = Math.abs(to - scrollTop);

            if (distance > scrollHeight) {
                scrollTop = to - upOrDown * scrollHeight;
            } else {
                scrollTop = scrollTop + upOrDown * gap;
            }

            if (Math.abs(distance) <= 3) {
                $scroll.scrollTop = to;
            } else {
                $scroll.scrollTop = scrollTop;
                requestAnimationFrame(step);
            }
        };

    step();
}

export function Utils__getShareSource() {
  const source = Utils__getQuery(location.href, 'source');

  return source == 'liulanqi' ? '浏览器' : '想看';
}

export function Utils__postMessage(options) {
  window.frames['mi-detail__iframe'].postMessage({
    order: options.order,
    param: options.param || {},
  }, '*');
}

/*
 * oaid升级后，获取imei, oaid的方法统一用客户端提供的新方法
 * 旧版客户端仍然使用getImeiMd5方法获取imei
    * */
export function Utils__getDeviceMessage() {
    const deviceMessage = {
        imei2: Utils__getImeiMd5(),
    };

    try {
        return JSON.parse(window.miui.getDeviceMessage()) || deviceMessage;
    } catch(e) {
        return deviceMessage;
    }
}

/*
 * oaid升级后，deviceId获取规则：
 *  有imei时，返回imei；取不到imei时，返回oaid。
    * */
export function Utils__getNativeDeviceId(deviceMessage) {
    deviceMessage = deviceMessage || Utils__getDeviceMessage();

    return deviceMessage.imei2 || deviceMessage.oaid;
}

/* 浏览器11.0后有简洁版和资讯版的区分，打点的appId不同 */
export function Utils__isSimpleHome() {
    try {
        return window.miui.isSimpleHome();
    } catch (e) {}
}

/* 浏览器11.7后 图文详情页native化，依据 浏览器版本是否支持native 来决定是否加载详情页 */
export function Utils__isDetailFragmentShow() {
    try {
        if (window.miui.shouldShowInfo() === 'false') {
            return false;
        }
    } catch (e) {}

    return true;
}

/* 浏览器11.7后 当文章加载失败 通知客户端 */
export function Utils__notifyClientArticleNotFound() {
    try {
        return window.miui.articleNotFound();
    } catch (e) {}
}
